import React from 'react'

const Error404Banner = () => {
  const lettersAnimation = '10s'
  const barsAnimation = '5s'

  return (
    <svg
      viewBox={'0 0 1010 360'}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className="error-page__banner-container"
    >
      <path
        d="M248.6 317.6L125 317.2V275.2L233.4 104H303V275.2H337.8V317.6H303V384H248.6V317.6ZM249 274.4V169.2L180.6 274.4H249Z"
        fill="#E5E7EB"
      >
        <animate
          attributeType="XML"
          attributeName="fill"
          values="#E5E7EB;#9CA3AF;#E5E7EB"
          dur={lettersAnimation}
          repeatCount="indefinite"
        />
      </path>
      <path
        d="M803.6 317.6L680 317.2V275.2L788.4 104H858V275.2H892.8V317.6H858V384H803.6V317.6ZM804 274.4V169.2L735.6 274.4H804Z"
        fill="#E5E7EB"
      >
        <animate
          attributeType="XML"
          attributeName="fill"
          values="#E5E7EB;#9CA3AF;#E5E7EB"
          dur={lettersAnimation}
          repeatCount="indefinite"
        />
      </path>
      <path d="M452.6 265.5V268" stroke="#9CA3AF" strokeLinecap="round" />
      <path d="M468.6 166V333" stroke="#E5E7EB" />
      <path d="M553.6 166V333" stroke="#E5E7EB" />
      <path d="M511.6 153V333" stroke="#E5E7EB" />
      <circle cx="511.6" cy="218" r="17" fill="#F3F4F6" stroke="#9CA3AF" />
      <circle cx="511.6" cy="218" r="11" fill="#F3F4F6" stroke="#9CA3AF" />
      <circle cx="452.6" cy="280.5" r="5" stroke="#9CA3AF" />
      <circle cx="452.6" cy="266.5" r="4" stroke="#9CA3AF" />
      <path d="M452.1 280.5H464.1" stroke="#9CA3AF" strokeWidth="4" strokeLinecap="round" />
      <path
        d="M511.1 98C439.027 98 380.6 156.658 380.6 229.017V338.5H435.188V229.017C435.188 186.926 469.175 152.805 511.1 152.805C553.025 152.805 587.012 186.926 587.012 229.017V338.5H641.6V229.017C641.6 156.658 583.173 98 511.1 98Z"
        fill="#E5E7EB"
      >
        <animate
          attributeType="XML"
          attributeName="fill"
          values="#E5E7EB;#9CA3AF;#E5E7EB"
          dur={lettersAnimation}
          repeatCount="indefinite"
        />
      </path>
      <path
        d="M435.188 338.5V229.017C435.188 186.926 469.175 152.805 511.1 152.805C553.025 152.805 587.012 186.926 587.012 229.017V338.5"
        stroke="#9CA3AF"
        strokeWidth="3"
      />
      <rect x="70.6454" y="156.638" width="47.2979" height="22.7731" rx="1.75177" fill="#E5E7EB">
        <animate
          attributeType="XML"
          attributeName="x"
          values="70.6454;80;70.6454"
          dur={barsAnimation}
          repeatCount="indefinite"
        />
      </rect>
      <rect x="629.752" y="52.5532" width="47.2979" height="22.7731" rx="1.75177" fill="#E5E7EB">
        <animate
          attributeType="XML"
          attributeName="x"
          values="629.752;640;629.752"
          dur={barsAnimation}
          repeatCount="indefinite"
        />
      </rect>
      <rect x="954.34" y="244.227" width="47.2979" height="22.7731" rx="1.75177" fill="#E5E7EB">
        <animate
          attributeType="XML"
          attributeName="x"
          values="954.34;944;954.34"
          dur={barsAnimation}
          repeatCount="indefinite"
        />
      </rect>
      <rect x="37.3617" y="209.192" width="31.5319" height="22.7731" rx="1.75177" fill="#E5E7EB">
        <animate
          attributeType="XML"
          attributeName="x"
          values="37.3617;27;37.3617"
          dur={barsAnimation}
          repeatCount="indefinite"
        />
      </rect>
      <rect x="647.27" width="31.5319" height="22.7731" rx="1.75177" fill="#E5E7EB">
        <animate
          attributeType="XML"
          attributeName="x"
          values="647.27;657;647.27"
          dur={barsAnimation}
          repeatCount="indefinite"
        />
      </rect>
      <rect x="37.3617" y="182.915" width="64.8156" height="22.7731" rx="1.75177" fill="#E5E7EB">
        <animate
          attributeType="XML"
          attributeName="x"
          values="37.3617;47;37.3617"
          dur={barsAnimation}
          repeatCount="indefinite"
        />
      </rect>
      <rect x="652.525" y="26.2766" width="64.8156" height="22.7731" rx="1.75177" fill="#E5E7EB">
        <animate
          attributeType="XML"
          attributeName="x"
          values="652.525;642;652.525"
          dur={barsAnimation}
          repeatCount="indefinite"
        />
      </rect>
      <rect x="917.553" y="217.95" width="64.8156" height="22.7731" rx="1.75177" fill="#E5E7EB">
        <animate
          attributeType="XML"
          attributeName="x"
          values="917.553;927;917.553"
          dur={barsAnimation}
          repeatCount="indefinite"
        />
      </rect>
      <rect x="367.206" y="49.0497" width="64.8156" height="22.7731" rx="1.75177" fill="#E5E7EB">
        <animate
          attributeType="XML"
          attributeName="x"
          values="367.206;357;367.206"
          dur={barsAnimation}
          repeatCount="indefinite"
        />
      </rect>
      <rect x="5" y="338" width="1000" height="75" fill="#f3f4f6" />
      <path d="M5 337.5H1005" stroke="#9CA3AF" strokeWidth="10" strokeLinecap="round" />
    </svg>
  )
}

export default Error404Banner
